import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { MarketVisionSettings } from '../@types/Company';

interface SalesDataState {
  years: string[];
  nbSaleStatements: MarketVisionSettings;
  nbMandates: MarketVisionSettings;
  nbPreSaleStatements: MarketVisionSettings;
  pricePreSaleStatements: MarketVisionSettings;
  realSales: MarketVisionSettings;
  salesData: Record<string, any>;
}

const initialState: SalesDataState = {
  years: [],
  nbSaleStatements: {},
  nbMandates: {},
  nbPreSaleStatements: {},
  pricePreSaleStatements: { value: '' },
  realSales: {},
  salesData: {},
};

const salesDataSlice = createSlice({
  name: 'salesData',
  initialState,
  reducers: {
    setYears(state, action: PayloadAction<string[]>) {
      state.years = action.payload;
    },
    setSalesData(state, action: PayloadAction<Record<string, any>>) {
      state.salesData = action.payload;
    },
    setNbSaleStatements(state, action: PayloadAction<MarketVisionSettings>) {
      state.nbSaleStatements = action.payload;
    },
    setNbMandates(state, action: PayloadAction<MarketVisionSettings>) {
      state.nbMandates = action.payload;
    },
    setNbPreSaleStatements(state, action: PayloadAction<MarketVisionSettings>) {
      state.nbPreSaleStatements = action.payload;
    },
    setPricePreSaleStatements(state, action: PayloadAction<MarketVisionSettings>) {
      state.pricePreSaleStatements = action.payload;
    },
    setRealSales(state, action: PayloadAction<MarketVisionSettings>) {
      state.realSales = action.payload;
    },
  },
});

export const {
  setYears,
  setSalesData,
  setNbSaleStatements,
  setNbMandates,
  setNbPreSaleStatements,
  setPricePreSaleStatements,
  setRealSales,
} = salesDataSlice.actions;

export default salesDataSlice.reducer;
